import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton, InputText, InputCheckbox, InputTypeAhead } from "@loanbossinc/component-library";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
  }
`;

const ContentWrapper = styled.div`
  display:flex;
  flex-direction: column;
`;
const SubTitle = styled.span`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-bottom: 16px;
  color: #000000;
`;
const DataWrapperRow = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  margin=bottom:10px;
`;
const StyledDialog = styled(Dialog)`
  margin: auto;
  width: 696px;
`;
export default function RefreshHolidayModal({ title, isOpen, onClose, onAccept, countryCodes, updateParams }) {
  const [updateItem, setUpdateItem] = useState(null);
  const [disableAccept, setDisableAccept] = useState(false);

  useEffect(() => {
    setUpdateItem(updateParams);
  }, [updateParams]);

  const handleChange = (name, value) => {
    setUpdateItem({
      ...updateItem, // spreading the unchanged updateItem
      [name]: value // changing the state of *changed updateItem*
    });
  };

  return (
    <StyledDialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <StyledDialogIconButton onClick={onClose}>
        <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
      </StyledDialogIconButton>
      <StyledDialogContent>
        <SubTitle>This will replace all manual overrides for the Country and Dates selected.</SubTitle>
        <ContentWrapper>
          {updateItem &&
            <DataWrapperRow>
              <InputTypeAhead
                id="updateItem.cityId"
                name="updateItem.cityId"
                value={updateItem.cityId}
                label="Country"
                options={countryCodes}
                displayWith={option => option && option.name}
                setValueWith={option => option && option.id}
                onChange={e => handleChange("cityId", e)}
                variant="filled"
                className="input"
                style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }}
              />

              <InputText
                placeholder="Value"
                label={"Year From"}
                name="yearFrom"
                variant="filled"
                onChange={e => handleChange(e.target.name, e.target.value)}
                style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }}
                value={updateItem.yearFrom}
              />
              <InputText
                placeholder="Value"
                label={"Year To"}
                name="yearTo"
                variant="filled"
                onChange={e => handleChange(e.target.name, e.target.value)}
                style={{ width: "190px", marginLeft: "5px", marginRight: "5px" }}
                value={updateItem.yearTo}
              />
              <div>
                <InputCheckbox
                  name="overwriteExisting"
                  value={updateItem.overwriteExisting}
                  label={"Overwrite Existing"}
                  onChange={e => handleChange(e.target.name, e.target.checked)}
                />
              </div>
            </DataWrapperRow>}
        </ContentWrapper>
      </StyledDialogContent>
      <DialogActions>
        {onClose && <SecondaryButton size={"sm"} onClick={onClose} label="Cancel" style={{ "margin-right": "16px" }} />}
        <PrimaryButton disabled={disableAccept} size={"sm"} onClick={() => onAccept(updateItem)} label="Refresh" />
      </DialogActions>
    </StyledDialog>
  );
}
